module.exports = __webpack_public_path__ + "static/media/view-initiatives.3f2e05b4.svg";